module.exports = __webpack_public_path__ + "static/media/IntegratedPlanning.b4505910.svg";